export { default as PrivateRoute } from './PrivateRoute';
